import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import { supportedRuleVariants } from '../../hooks/useRuleActions/useRuleActions';
import { TsrctRuleVariant } from '@/generated/gql/graphql';

export const ruleDetailDialogFormSchema = z.object({
  name: z.string().min(3),
  responsibleUsers: z.array(z.string()),
  // Only the variants tesseract can store. @procureai/rule-builder also lists the core-only ones.
  variant: z.enum(supportedRuleVariants),
});

export type RuleDetailDialogFormData = z.infer<typeof ruleDetailDialogFormSchema>;

export const ruleDetailDialogDefaultValues: DefaultValues<RuleDetailDialogFormData> = {
  variant: TsrctRuleVariant.SOURCING,
};
